module.exports = __webpack_public_path__ + "static/media/AI_14.7f47a4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_14.png
// module id = 129
// module chunks = 0